/**
 * La forme parallèle de 4e (11/10/2026). Le ministère n'a pas d'outil de positionnement en 4e : ce sont nos
 * deux textes, réécrits d'après l'audit externe (EvalNatClgBedier/audit_variantes_francais_2026-10-11.md).
 * « Le Copiste d'Ombreval » ne suit plus la trame du Petit Chose de septembre ; « Volcans sous la mer » a la
 * difficulté du document officiel et des faits vérifiés. Les questions sont neuves : aucune ne reprend un item
 * de septembre (ni la tâche, ni la clé, ni la grille), sinon on mesurerait la mémoire.
 *
 * Pas de seuils étalonnés : la progression se lit en taux, par support et par compétence, sans groupe.
 */
import { SUPPORT_COPISTE, QUESTIONS_COPISTE } from './copiste4e';
import { SUPPORT_VOLCANS, QUESTIONS_VOLCANS } from './volcans4e';

/**
 * Les items de septembre rangés dans les trois compétences. En 4e, le libellé du ministère décrit l'item
 * (« Identifier le titre approprié »), pas sa famille : le classement suit l'attendu de chaque item, comme les
 * familles de 6e. Petit Chose 3 / 4 / 3, Volcans sous la glace 2 / 4 / 5 ; les textes de la forme gardent la
 * même répartition.
 */
const COMPETENCES_DE_SEPTEMBRE = {
    // Q01 titre approprié · Q02 information littérale · Q03 informations reformulées · Q04 inférence sur un
    // passage · Q05 émotion déduite d'une attitude · Q06 information reformulée · Q07 mettre en relation et
    // inférer · Q08 imaginaire ou réalité (implicite) · Q09 atmosphère du lieu · Q10 structure narrative (le nom
    // du narrateur, par la chaine des reprises dans les dialogues)
    'Petit Chose': [
        'sens_global', 'explicite', 'explicite', 'inference', 'inference',
        'explicite', 'inference', 'inference', 'sens_global', 'sens_global',
    ],
    // Q01 type de publication (visée) · Q02 un texte et une image · Q03 information explicite · Q04 un texte et une
    // carte · Q05 information explicite · Q06 fonction d'un schéma · Q07 l'« oasis » (inférence) · Q08 idée
    // principale d'une partie · Q09 une image et un passage · Q10 sens global · Q11 structure du document
    'Volcans sous la glace': [
        'sens_global', 'inference', 'explicite', 'inference', 'explicite', 'sens_global',
        'inference', 'sens_global', 'inference', 'sens_global', 'sens_global',
    ],
};

/** La forme parallèle de 4e : deux textes écrits pour TanoEd, leurs questions, pas de seuils. */
export const FORME_4E = {
    id: 'forme-4e',
    niveau: '4',
    titre: 'Forme parallèle de quatrième (TanoEd)',
    provenance: 'Écrit pour TanoEd',
    origine: 'Ces textes ont été écrits pour TanoEd, du même genre que ceux de septembre, aux mêmes compétences.',
    remplace: ["Compréhension de l'écrit Petit Chose", "Compréhension de l'écrit Volcans sous la glace"],
    competencesDeSeptembre: COMPETENCES_DE_SEPTEMBRE,
    seuils: null,
    textes: [
        { typeLabel: "Compréhension de l'écrit Le Copiste d'Ombreval", support: 'litteraire', SUPPORT: SUPPORT_COPISTE, questions: QUESTIONS_COPISTE },
        { typeLabel: "Compréhension de l'écrit Volcans sous la mer", support: 'documentaire', SUPPORT: SUPPORT_VOLCANS, questions: QUESTIONS_VOLCANS },
    ],
};
